import React, { useEffect } from 'react';
import {
  useGetCustomSelectButtonElement,
  useSetStringDefaultValue,
} from '../../hooks/init';
import { PlaceholderType, SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import CustomSingleSelect from '../../components/CustomSingleSelect';
import './index.scss';
import { AllFilterPointType } from '@op/operationLog/pages/filter';

export default function CommonSingleSelect({
  onChange,
  defaultValue,
  defaultKey,
  filterValue,
  oriDefaultFilter,
  backOriDefaultValue,
  lang,
  returnKey,
  options,
  initValue,
  singlePlaceholder,
  dealwithReturnValue = (value: string) => value,
  dealwithValue,
  pointKey,
}: SingleCommonType & {
  returnKey: string;
  options: Array<{ text: string; value: string }>;
  initValue?: string;
  singlePlaceholder: PlaceholderType;
  dealwithReturnValue?: (value: string) => string | number | boolean;
  dealwithValue?: (value: string | number) => string;
  pointKey?: AllFilterPointType;
}) {
  const {
    value: singleSelects,
    setValue: setSingleSelects,
    diffClassName,
  } = useSetStringDefaultValue({
    defaultValue,
    filterValue,
    defaultKey: returnKey,
    initValue: initValue || options[0].value,
    dealwithValue,
    oriDefaultFilter,
    backOriDefaultValue,
  });

  const { formatOptionsMessage, formatMessage } = useLanguage();

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  useEffect(() => {
    const [text] = getButtonElement();
    onChange?.(
      returnKey,
      commonBackInfo(
        { [returnKey]: dealwithReturnValue(singleSelects) },
        { [defaultKey]: text },
      ),
    );
  }, [singleSelects, formatMessage]);

  return (
    <div className={`common-single-select-wrapper ${diffClassName}`}>
      <CustomSingleSelect
        ref={customSelectRef}
        pointKey={pointKey}
        placeholderText={singlePlaceholder[lang]}
        selectValueInfo={[singleSelects, setSingleSelects]}
        options={formatOptionsMessage(options)}
      />
    </div>
  );
}
